/* src/app/features/tranches/modal-fator-ecg/modal-fator-ecg.component.scss */
.alert {
  margin-top: 1em !important;
}
/*# sourceMappingURL=modal-fator-ecg.component.css.map */
